
import { Vue, prop, Options } from "vue-class-component";
import { HangingIncoming } from "@/domain/entities/HangingIncoming";
import { HangingLastMile } from "@/domain/entities/HangingLastMile";
import { FcsPermissionSttHanging } from "@/feature-flags/flags-permission-stt-hanging";

class Props {
  data = prop<(HangingIncoming | HangingLastMile)[]>({
    default: () => [],
    required: false
  });
  isLastMile = prop<boolean>({
    default: false,
    required: false,
    type: Boolean
  });
  isOutgoing = prop<boolean>({
    default: false
  });
  isConsoleBkd = prop<boolean>({
    default: false
  });
}

@Options({
  emits: ["update", "download"]
})
class CariSTT extends Vue.with(Props) {
  get isDisableButton() {
    if (this.isLastMile || this.isOutgoing || this.isConsoleBkd) {
      return (this.data as HangingLastMile[])
        .flatMap((item) => item.groups)
        .flatMap((group) => group.stts)
        .flatMap((stt) => !stt.isChecked)
        .every(Boolean);
    }

    return (this.data as HangingIncoming[])
      .flatMap((item) => item.groups)
      .flatMap((group) => group.awbs)
      .flatMap((awb) => awb.stts)
      .flatMap((stt) => !stt.isChecked)
      .every(Boolean);
  }

  updateStatus(status: string) {
    this.$emit("update", status);
  }

  onDownload() {
    this.$emit("download");
  }

  get isUpdateMissingEnabled() {
    return FcsPermissionSttHanging.permission_button_update_missing_enable.isEnabled();
  }

  get isUpdateDamageEnabled() {
    return FcsPermissionSttHanging.permission_button_update_damage_enable.isEnabled();
  }
}
export default CariSTT;
